import Splide from "@splidejs/splide";

window.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('#cf-location-popular-makes') && matchMedia("(max-width: 768px)").matches) {
        new Splide('#cf-location-popular-makes', {
            perPage: 4,
            perMove: 1,
            loop: true,
            pagination: true,
            rewind: true,
            arrows: true,
            autoplay: false,
            arrowPath: "",
            breakpoints: {
                1440: {
                    perPage: 4,
                },
                1250: {
                    perPage: 3,
                },
                900: {
                    perPage: 1,
                    arrows: false
                },
            }
        }).mount();
    }

    if (document.querySelector('.block-cmc-trustpilot-reviews')) {
        new Splide('.reviews-splide', {
            perPage: 3,
            perMove: 1,
            loop: true,
            pagination: false,
            rewind: true,
            arrows: true,
            autoplay: true,
            arrowPath: "",
            interval: 10000,
            breakpoints: {
                900: {
                    perPage: 1,
                    perMove: 1,
                    arrows: false,
                    pagination: true
                },
            },
        }).mount();
    }

    if (document.querySelector('#bccf-location-most-popular-cars') && matchMedia("(max-width: 768px)").matches) {
        new Splide('#bccf-location-most-popular-cars', {
            perPage: 4,
            perMove: 1,
            loop: true,
            pagination: true,
            rewind: true,
            arrows: true,
            autoplay: false,
            arrowPath: "",
            breakpoints: {
                1440: {
                    perPage: 4,
                },
                1250: {
                    perPage: 3,
                },
                900: {
                    perPage: 1,
                    arrows: false
                },
            }
        }).mount();
    }
});
